export enum PlanStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
